<template>
  <div>
    <van-cell title="商品详情" class="good_delite">
      <template #icon>
        <van-icon name="arrow-left" @click="back"/> 
        <div @click="back">返回</div>
      </template>
    </van-cell>
    <!-- 轮播图 -->
    <van-swipe class="swipe" @change="onChange" >
      <van-swipe-item v-for="(item, index) in images" :key="index">
        <img class="img-swipe" :src="item">
      </van-swipe-item>
      <template #indicator>
        <div class="custom-indicator">{{ current + 1 }}/{{images.length}}</div>
      </template>
    </van-swipe>
    <!-- 商品信息 -->
    <!-- <van-cell :title="goods.name" :value="goods.sale" :label="goods.describe" class="goods" /> -->
    <!-- 配送信息 -->
    <div class='delivery'>       
      <van-cell-group  v-for="(item,index) in deliveryInfo" :key="index">
        <van-cell :title="item.title" :value="item.value" />
      </van-cell-group>
    </div>
    <!-- 图片详情 -->
    <van-cell title="商品详情" class="good_img" />
    <div class='goodsImgs'>
      <img width="100%" :src="detailsImg" >
    </div>
    <div class="fix">
      <van-button  round type="primary" @click="callMe">联系我们</van-button>
      <van-button @click="isRegisteredShow"  round type="primary">立即注册</van-button>
    </div>
    <registered :registeredShow=registeredShow @close="close" @closeSunccess="closeSunccess" :show=show></registered>
  </div>
</template>

<script>
import registered from "../common/registered"

export default {
  components:{
    registered
  },
  data() {
    return {
      show:false,
      registeredShow:false,
      current: 0,
      images: [],
      goods:{
        name:'',sale:'',describe:''
      },
      deliveryInfo:[
        {title:'配送',value:'次日达'},
        {title:'服务',value:'田野专送·支持24小时退换'},
        {title:'联系热线',value:'400-888-1668'},
      ],
      detailsImg: '',
    }
  },
  mounted() {
    this.detailList()
  },
  methods: {
    back() {
      this.$router.back(-1)
    },
    onChange(index) {
      this.current = index;
    },
    detailList() {
      this.$axios.get(`goods/permit/goods/${this.$route.query.goodsId}`)
        .then(res =>{
          const { picUrl, detailsPicUrl, name, unitValue, unitLabel  } = res.data.data
          this.images.push(picUrl)
          this.detailsImg = detailsPicUrl || picUrl
          this.goods.name = name + '  ' + unitValue + unitLabel
          this.goods.sale = '销量:' + this.$route.query.saleRatio
        })
        .catch(() =>{})
    },
    isRegisteredShow() {
      this.registeredShow = true
    },
    // 关闭注册弹窗
    close() {
      this.registeredShow = false
      this.show = false
    },
    closeSunccess() {
      this.registeredShow = false
      this.show = false
    },
    callMe() {
      window.location.href = 'tel://' + '4008881668'
    }
  }
}
</script>

<style scoped lang='scss'>
.van-icon {
  line-height: 24px;
}
.good_delite {
  .van-cell__title {
    text-align: center;
    padding-right: 30px;
  }
}
.img-swipe {
  width: 100%;
  height: 400px;
}
.custom-indicator {
  position: absolute;
  right: 5px;
  bottom: 5px;
  padding: 2px 5px;
  font-size: 12px;
  background: rgba(0, 0, 0, 0.1);
}

.goods {
  margin-top:-5px ;
  .van-cell {
  height: 80px
  }
  .van-cell__title {
    text-align: left;
  }
}
.delivery {
  margin-top:-8px;
  .van-cell{
    margin-top:-2px;
  }
  .van-cell__title {
    width: 80px;
    color:#969799;
    font-size: 16px;

  }
  .van-cell__value{
    text-align: left;
    margin-left: -200px;
    color:#323233;
    font-size: 16px;
  }
}
.good_img {
  margin-top: 10px;
}
.fix {
  padding: 5px 0px;
  display: flex;
  justify-content:space-around;
  width: 100%;
  position: absolute;
  top: 93.4%;
  background-color: #fff;
  .van-button {
    width: 130px;
    height:40px
  }
  .van-button:nth-child(1) {
    background-color: #a6a6a6;
    border-color:#a6a6a6
  }
}
.goodsImgs {
  margin-bottom: 40px;
}
</style>
